export { NileFloatingPanel } from './nile-floating-panel';
